/**
 * @description adds a tag to a message string.
 *
 * @example
 * // returns '[fetchThings] (validation): validation error message'
 * tag('validation error message', fetchThings', 'validation')
 *
 * @example
 * // returns '[getThings]: some message'
 * tag('some message', getThings')
 *
 * @param message - main part of the message string
 * @param caller - the name of the function that will log the message string
 * @param msgType - the kind of message that is being logged
 *
 * @returns - A tagged message string that can be used inside console logs or errors
 * */
export const tagMessage = (message: string, caller?: string, msgType?: string): string =>
    `[${caller ?? ''}] (${msgType ?? ''}): ${message}`.replace(/(\[\]|\(\))/g, '').replace(/\s:/g, ':')
